import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/type-expenses',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/settings/type-expense/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/settings/type-expenses/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/type-expenses',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/type-expenses/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/type-expenses/${id}`,
      method: 'delete',
  })
}
